/* eslint-disable */
export default {
  createCallLog: 'Anrufprotokoll anlegen',
  viewInSalesforce: 'In Salesforce anzeigen',
  createLog: 'Protokoll erstellen',
} as const;

// @key: @#@"createCallLog"@#@ @source: @#@"Create call log"@#@
// @key: @#@"viewInSalesforce"@#@ @source: @#@"View in Salesforce"@#@
// @key: @#@"createLog"@#@ @source: @#@"Create log"@#@
